<template>
    
    <div>
      <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
      <UpTable :hoverable="true" :data='fetchClassrooms' :paginated="fetchClassrooms.length > 10" :per-page="10">
        <UpTableColumn label="Name" field="name" v-slot="props" sortable>
          {{ props.row.name }}
        </UpTableColumn>
        <UpTableColumn label="Action" v-slot="props">
          <div class="buttons is-right" style="display:block">
            <b-button class="button is-small is-primary" @click="$router.push({ name: 'classroom-details', params: { id: props.row._id } })" type="button">
              <b-icon icon="eye" size="is-small"></b-icon>
            </b-button>
            <b-button v-if="canManage" class="button is-small is-primary" @click="editClassroom(props.row._id)"  type="button">
              <b-icon icon="pencil" size="is-small"></b-icon>
            </b-button>
            <b-button v-if="canManage" class="button is-small is-danger" type="button"  @click="deleteClassroom(props.row._id)">
              <b-icon icon="delete" size="is-small"></b-icon>
            </b-button>
          </div>
        </UpTableColumn>
      </UpTable>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import SetClassroom from './SetClassroom.vue';
export default {
  name : 'classroom-table',
  data(){
      return{
        isLoading:false,
        // modalUpdateClassroom:false,
      }
  },
  components:{
    // SetClassroom
  },
	props : {
    },
    methods: {
    ...mapActions(['loadClassrooms']),
    editClassroom(id) {
      this.edit_id = id
      // this.modalUpdateClassroom= true
    },
    deleteClassroom(id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.deleteClassroom({ token: this.userToken, id }).then(() => {
            this.$buefy.toast.open({
              message: 'Classroom deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    },
    
    },
    computed: {
      ...mapGetters(['fetchClassrooms', 'getTeacherToken', 'getUserType']),
      canManage() {
        return this.getUserType === 'SA' || this.getUserType === 'A'
      }
    },
    created(){
      this.isLoading=true
      this.loadClassrooms({ token: this.getTeacherToken
      }).then(() => {
          this.isLoading = false
      });
    },
}
</script>
<style scoped>
</style>